let observer = null

const cv = document.querySelector('.sc21-CreditcardCashingOnline-cv')
const observeOptions = {
  rootMargin: '-100% 0px 0px 0px',
  threshold: [0.0],
}

function observeHandler(entries) {
  if (entries[0].isIntersecting) {
    cv.classList.add('-sticky')
  } else {
    cv.classList.remove('-sticky')
  }
}

function creditcardCashingOnline() {
  cv.classList.remove('-sticky')
  cv.classList.remove('-hidden')
  let target = document.querySelector('#observer-target')
  observer = new IntersectionObserver(observeHandler, observeOptions)
  observer.observe(target)
}
creditcardCashingOnline()
